import { IAsset } from "../../models/IAsset";
import { ASSETS_GET_ASSETSLIST } from "./assets-types";

export const setAssets = (assets: IAsset[]) => (dispatch: any) =>
  dispatch({ type: ASSETS_GET_ASSETSLIST, payload: assets });
